import { Filter } from './filter.types';

export enum LOADING_STATUS {
  NOT_STARTED = 0,
  LOADING = 1,
  LOADED = 2,
  ERROR = 3,
}

export interface AppState {
  azureAccessToken: null | string;
  azureIdToken: null | string;
  profile: null | UserProfile;
  customerFilters: null | Filter[];
  materialFilters: null | Filter[];
}

export type UserProfile = {
  fullName: string;
  emailAddress: string;
  avatar: string | null;
};
export type Paggination = {
  page: number;
  limit: number;
};

export type GetOrderRequestParams = Paggination & {
  sortColumn: string;
  sortDirection: string;
  // includeDeleted?: boolean;
  searchTerm?: string;
  searchColumns?: string[];
};

export type GetFutureOrderTransactionParmas = Paggination & {
  userCode: string;
};

export enum FormState {
  VALID = '@form/valid',
  INVALID = '@form/invalid',
  NOT_VALIDATED = '@form/not_validated',
}

enum SelectAllStatus {
  checked = 'checked',
  indeterminate = 'indeterminate',
  unchecked = 'unchecked',
}
